<template>
  <div style="width: 100%">
    <!-- <v-btn color="pink" dark @click.stop="drawer = !drawer">
              Menu
            </v-btn> -->
    <div v-if="!loggedIn">
      <NeedLogin></NeedLogin>
    </div>
    <div v-else>
      <v-row align="center">
        <v-item-group v-model="window" class="shrink mr-6" mandatory>
          <v-item v-for="n in windowlength" :key="n">
            <div></div>
          </v-item>
        </v-item-group>

        <v-col>
          <v-window v-model="window" class="elevation-1" vertical>
            <!-- WINDOW 0 -->
            <v-window-item
              ><v-card flat>
                <v-card-text>
                  <v-row class="mb-4" align="center">
                    <v-btn icon>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                    <strong class="text-h6">{{ curritemtitle }}</strong>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      small
                      dark
                      @click.stop="drawer = !drawer"
                      v-if="!drawer"
                    >
                      Show Menu
                    </v-btn>
                  </v-row>

                  <p>Side 1. {{ curritemtitle }}</p>
                </v-card-text>
              </v-card>
            </v-window-item>
            <!-- WINDOW 1 -->
            <v-window-item>
              <v-card flat>
                <v-card-text>
                  <v-row class="mb-4" align="center">
                    <v-btn icon>
                      <v-icon>mdi-lock-open-plus-outline</v-icon>
                    </v-btn>
                    <strong class="text-h6">{{ curritemtitle }}</strong>
                    <v-spacer></v-spacer>

                    <v-btn
                      color="primary"
                      small
                      dark
                      @click.stop="drawer = !drawer"
                      v-if="!drawer"
                    >
                      Show Menu
                    </v-btn>
                  </v-row>

                  <p>Side 2. {{ curritemtitle }}</p>
                </v-card-text>
              </v-card>
            </v-window-item>
            <!-- WINDOW 2 -->
            <v-window-item>
              <v-card flat>
                <v-card-text>
                  <v-row class="mb-4" align="center">
                    <v-btn icon>
                      <v-icon>mdi-cellphone-message</v-icon>
                    </v-btn>
                    <strong class="text-h6">{{ curritemtitle }}</strong>
                    <v-spacer></v-spacer>

                    <v-btn
                      color="primary"
                      small
                      dark
                      @click.stop="drawer = !drawer"
                      v-if="!drawer"
                    >
                      Show Menu
                    </v-btn>
                  </v-row>
                  <SelectBoxForAdmin @box_changed="boxSelected"></SelectBoxForAdmin>
                  <!-- <p>{{box.EventId}}</p> -->
                  <p>{{ curritemtitle }} to selected users in box</p>
                  <p>{{ curritemtitle }} to all sms subscribers</p>
                  <p>{{this.box}}</p>
                </v-card-text>
              </v-card>
            </v-window-item>

            <!-- WINDOW 3 -->
            <v-window-item
              ><v-card flat>
                <v-card-text>
                  <v-row class="mb-4" align="center">
                    <v-btn icon>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                    <strong class="text-h6">{{ curritemtitle }}</strong>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      small
                      dark
                      @click.stop="drawer = !drawer"
                      v-if="!drawer"
                    >
                      Show Menu
                    </v-btn>
                  </v-row>

                  <p>Slide 4. {{ curritemtitle }}</p>
                </v-card-text>
              </v-card>
            </v-window-item>
            <!-- WINDOW 4 -->
            <v-window-item>
              <v-card flat>
                <v-card-text>
                  <v-row class="mb-4" align="center">
                    <v-btn icon>
                      <v-icon>mdi-lock-open-plus-outline</v-icon>
                    </v-btn>
                    <strong class="text-h6">{{ curritemtitle }}</strong>
                    <v-spacer></v-spacer>

                    <v-btn
                      color="primary"
                      small
                      dark
                      @click.stop="drawer = !drawer"
                      v-if="!drawer"
                    >
                      Show Menu
                    </v-btn>
                  </v-row>

                  <p>Side 4. {{ curritemtitle }}</p>
                </v-card-text>
              </v-card>
            </v-window-item>
            <!-- WINDOW 5 -->
            <v-window-item>
              <v-card flat>
                <v-card-text>
                  <v-row class="mb-4" align="center">
                    <v-btn icon>
                      <v-icon>mdi-cellphone-message</v-icon>
                    </v-btn>
                    <strong class="text-h6">{{ curritemtitle }}</strong>
                    <v-spacer></v-spacer>

                    <v-btn
                      color="primary"
                      small
                      dark
                      @click.stop="drawer = !drawer"
                      v-if="!drawer"
                    >
                      Show Menu
                    </v-btn>
                  </v-row>

                  <p>{{ curritemtitle }} Trallala window 5</p>
                </v-card-text>
              </v-card>
            </v-window-item>

            <!-- WINDOW EDIT BOX OPENERS-->
            <v-window-item
              ><v-card flat>
                <v-card-text>
                  <v-row class="mb-4" align="center">
                    <v-btn icon>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                    <strong class="text-h6">{{ curritemtitle }}</strong>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      small
                      dark
                      @click.stop="drawer = !drawer"
                      v-if="!drawer"
                    >
                      Show Menu
                    </v-btn>
                  </v-row>
                  <!-- <SelectBoxForAdmin @box_changed="boxSelected"></SelectBoxForAdmin>
                  <BoxRoles></BoxRoles>
                  <p>{{this.box}}</p> -->
                  <p>Side 1. {{ curritemtitle }}</p>
                </v-card-text>
              </v-card>
            </v-window-item>
            <!-- WINDOW 7 -->
            <v-window-item>
              <v-card flat>
                <v-card-text>
                  <v-row class="mb-4" align="center">
                    <v-btn icon>
                      <v-icon>mdi-lock-open-plus-outline</v-icon>
                    </v-btn>
                    <strong class="text-h6">{{ curritemtitle }}</strong>
                    <v-spacer></v-spacer>

                    <v-btn
                      color="primary"
                      small
                      dark
                      @click.stop="drawer = !drawer"
                      v-if="!drawer"
                    >
                      Show Menu
                    </v-btn>
                  </v-row>

                  <p>Slide 7. {{ curritemtitle }}</p>
                </v-card-text>
              </v-card>
            </v-window-item>
            <!-- WINDOW 8 -->
            <v-window-item>
              <v-card flat>
                <v-card-text>
                  <v-row class="mb-4" align="center">
                    <v-btn icon>
                      <v-icon>mdi-cellphone-message</v-icon>
                    </v-btn>
                    <strong class="text-h6">{{ curritemtitle }}</strong>
                    <v-spacer></v-spacer>

                    <v-btn
                      color="primary"
                      small
                      dark
                      @click.stop="drawer = !drawer"
                      v-if="!drawer"
                    >
                      Show Menu
                    </v-btn>
                  </v-row>

                  <p>{{ curritemtitle }} to selected users in box</p>
                  <p>{{ curritemtitle }} to all sms subscribers</p>
                </v-card-text>
              </v-card>
            </v-window-item>

            <!-- <v-window-item>3</v-window-item>
            <v-window-item>4</v-window-item>
            <v-window-item>5</v-window-item>
            <v-window-item>6</v-window-item>
            <v-window-item>7</v-window-item>
            <v-window-item>8</v-window-item>
            <v-window-item>9</v-window-item>
            <v-window-item>10</v-window-item>
            <v-window-item>11</v-window-item> -->

          </v-window>
        </v-col>
      </v-row>

      <v-col>
        <v-navigation-drawer v-model="drawer" absolute bottom temporary>
          <v-row align="center">
            <v-col>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ cookiePilotName }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col>
              <v-btn color="primary" small dark @click.stop="drawer = !drawer">
                Hide Menu
              </v-btn>
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-list-item link @click="menuclicked(infoitem)">
            <v-list-item-icon>
              <v-icon>{{ infoitem.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ infoitem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group no-action sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Box Actions</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list dense nav>
              <v-list-item
                v-for="item in menuitems2"
                :key="item.title"
                link
                @click="menuclicked(item)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-list-group>
          <v-list-group no-action sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Box Admin</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list dense nav>
              <v-list-item
                v-for="item in menuitems1"
                :key="item.title"
                link
                @click="menuclicked(item)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-list-group>
        </v-navigation-drawer>
      </v-col>
      <v-divider vertical></v-divider>
    </div>
  </div>
</template>

<script>
import NeedLogin from "@/components/Admin/NeedLogin.vue";
import SelectBoxForAdmin from "@/components/airbox/SelectBoxForAdmin.vue";
// import BoxRoles from "@/components/Admin/BoxRoles.vue";
import axios from "axios";

export default {
  name: "CheckIn",
  // regid: Number,
  data() {
    return {
      regid: Number,
      ac: String,
      isValid: false,
      box: [],
      statusResult: Number,
      statusResultMsg: String,
      statusToken: Number,
      cookieToken: Number,
      cookieRegId: Number,
      cookiePilotName: String,
      loggedIn: false,
      cancelBtnText: "Cancel",
      items: [],
      errors: [],
      drawer: true,
      menubuttontext: String,
      group: null,
      windowlength: 12,
      window: 0,
      curritemtitle: String,
      infoitem: { id: 0, title: "Info", icon: "mdi-information-outline" },
      menuitems1: [
        // { id: 0, title: "Info", icon: "mdi-information-outline" },
        {
          id: 1,
          title: "Open/Close a Box",
          icon: "mdi-lock-open-plus-outline",
        },
        { id: 2, title: "Send Message", icon: "mdi-cellphone-message" },
      ],
      menuitems2: [
        { id: 3, title: "Create Box", icon: "mdi-new-box" },
        { id: 4, title: "Edit Box", icon: "mdi-square-edit-outline" },
        { id: 5, title: "Box Templates", icon: "mdi-square-edit-outline" },
        { id: 6, title: "Edit Box Openers", icon: "mdi-square-edit-outline" },
        { id: 7, title: "Box History", icon: "mdi-format-list-bulleted" },
        { id: 8, title: "Notification enabling", icon: "mdi-format-list-bulleted" },
      ],
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    this.regid = null;
    this.isValid = false;
    this.getCookies();
    console.log(this.loggedIn);
    this.menubuttontext = "Hide Menu";
    this.curritemtitle = "Info";
    this.box = null;
  },
  methods: {
    submit() {
      var regId = this.regid;
      var ac = this.ac;
      var toSubmit = JSON.stringify({ ac });
      const uri = this.baseUrl + "getroles/" + regId;
      //   console.log(uri)
      //   console.log(toSubmit)
      this.sendpost(uri, toSubmit, 1);
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
            this.statusToken = response.data.Token;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
            this.statusToken = response.data[0].Token;
          }
          if (this.statusResult == 1) {
            this.cancelBtnText = "Done";
            this.isValid = false;
          }
          this.setAlert(this.statusResult);
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.cookiePilotName = this.$cookies.get("pgbname");
      this.regid = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
    menuclicked(item) {
      this.window = item.id;
      this.curritemtitle = item.title;
    },
    boxSelected(boxSelected)
    {
      this.box = boxSelected;
      console.log("box:",this.box);
    }
  },
  components: {
    NeedLogin,
    SelectBoxForAdmin,
    // BoxRoles
  },
  // watch: {
  //   group() {
  //     this.drawer = false;
  //   },
  // },
};
</script>

